<template lang="pug">
div(
    :id="id"
    class="list-wrapper"
)
    div(class="selection-list")
        template(
            v-for="item in items"
            :key="item.index"
        )
            Tooltip(
                v-if="item.tooltip?.value"
                :tip="item.tooltip?.value"
                :placement="item.tooltip?.placement"
            )
                InputRadioListTile(
                    :loading="loading"
                    :item="item"
                    :model-value="checked === item.index"
                    @update:model-value="updateModel(item.index)"
                )
            InputRadioListTile(
                v-else
                :loading="loading"
                :item="item"
                :model-value="checked === item.index"
                @update:model-value="updateModel(item.index)"
            )
    transition(
        name="dots"
    )
        LoadingDots(v-if="loading")
    ErrorText(
        v-if="error"
        :error="error"
    )
</template>

<script setup lang="ts">
import InputRadioListTile from './InputRadioListTile.vue'
import LoadingDots from 'widget-components/components/LoadingDots'
import ErrorText from '../ErrorText/ErrorText.vue'

import type { ListTileItem } from './types'
import Tooltip from 'widget-components/atoms/Tooltip/Tooltip.vue'
import type { BlockPath } from 'widget-components/integrations/CustomPage/types'

defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{
    id?: string
    items: ListTileItem[]
    loading?: boolean
    error?: string
    blockPath?: BlockPath
}>(), {
    items: () => [],
    loading: false,
    error: '',
})

const checked = defineModel<number>({ default: -1 })

const updateModel = (value: number) => {
    checked.value = checked.value === value ? -1 : value
}

</script>

<style lang="sass" scoped>
@import './InputRadioList.sass'
</style>
